import {
  USER_IMPERSONATE,
  USER_IMPERSONATE_END,
  USER_IMPERSONATE_LOADING,
  USER_IMPERSONATE_LOADED,
  PREVIEWS_CAS_DETAILS,
  USER_IMPERSONATE_RESET,
  ASSOCIATION_USER,
  SUPER_USER,
} from '../../actionTypes/Users/UserActionType';
import Api from '../../Api';
import { Auth } from 'aws-amplify';
import {
  sendGADimensions,
  setLoggedUserDetailsSuccess,
  setSessionUserActiveCAS,
  setUserInstitutionData,
} from './UserAction';
import { cleanReportMenu, setReportMenu } from '../Page/PageAction';
import { identity } from 'ramda';
const api = new Api();

function getUserImpersonateSuccess(payload) {
  return {
    type: USER_IMPERSONATE,
    payload,
  };
}

function getUserImpersonateEndSuccess(payload) {
  return {
    type: USER_IMPERSONATE_END,
    payload: {
      ...payload,
      userPersonated: null,
    },
  };
}

function getPreviousCasDetailsSuccess(payload) {
  return {
    type: PREVIEWS_CAS_DETAILS,
    payload,
  };
}

export const setUserImpersonateRequestStart = () => {
  return {
    type: USER_IMPERSONATE_LOADING,
  };
};

export const setUserImpersonateRequestComplete = () => {
  return {
    type: USER_IMPERSONATE_LOADED,
  };
};

export const resetUserImpersonateState = () => {
  return {
    type: USER_IMPERSONATE_RESET,
  };
};

export const setPreviousCasDetails = (casDetails) => {
  return (dispatch) => {
    dispatch(getPreviousCasDetailsSuccess(casDetails));
  };
};

export const impersonateUserEnd = () => {
  return async (dispatch, getStateFn) => {
    const state = getStateFn();
    const previousCasDetails = state.Impersonate.previousCasDetails;
    dispatch(setUserImpersonateRequestStart());
    try {
      Api.instance.cancelAllExcept(['postData']);

      const personData = await api.postData(`/rest/users/unimpersonate`);

      const awsSessData = await fetchCurrentAWSSessionData();

      const callback = (err) => {
        Api.instance.reset();

        const payload = {
          err,
          session: null,
        };

        const currentUserDetails = getUserDetailsFromImpersonateResponse(personData);
        dispatch(setLoggedUserDetailsSuccess(currentUserDetails));

        // restore last session data
        const isSuperUser = currentUserDetails.userRole === SUPER_USER;
        const isAssocUser = currentUserDetails.userRole === ASSOCIATION_USER;
        const {
          institutionDetails = {},
          reportMenus = null,
          activeCasDetails = {},
        } = isSuperUser ? {} : previousCasDetails;
        dispatch(isSuperUser ? setUserInstitutionData({}) : setUserInstitutionData(institutionDetails));
        dispatch(reportMenus ? setReportMenu(reportMenus) : cleanReportMenu());
        dispatch(activeCasDetails ? setSessionUserActiveCAS(activeCasDetails) : identity);

        /*
        Following code by Anil Shah which leads to errror when end impersonate on association user
        isAssocUser ?
           sendGADimensions(currentUserDetails.userPrincipalId, casDetails.name) : void 0;*/

        isAssocUser ? sendGADimensions(currentUserDetails.userPrincipalId, activeCasDetails.name) : void 0;

        setTimeout(() => {
          dispatch(getUserImpersonateEndSuccess(payload));
        }, 0);
      };

      awsSessData && personData
        ? awsSessData.currentAuthUser.refreshSession(awsSessData.currentSession.refreshToken, callback)
        : void 0;
    } catch (err) {
      console.error(err);
      dispatch(setUserImpersonateRequestComplete());
    }
  };
};

export const impersonateUserStart = () => {
  return async (dispatch, getStateFn) => {
    const state = getStateFn();
    const previewUser = state.Users.previewUser;
    const sessionUser = state.AppSession.userDetails;
    const activeCasDetails = state.AppSession.activeCasDetails;
    const institutionDetails = state.AppSession.institutionDetails;
    const reportMenus = state.Page.reportMenus;
    dispatch(setUserImpersonateRequestStart());
    try {
      const personData = await api.putData(`/rest/users/${previewUser.id}/impersonate`);
      const awsSessData = await fetchCurrentAWSSessionData();

      const callback = (err, session) => {
        const payload = {
          err,
          session,
          userPersonated: personData,
        };
        dispatch(getUserImpersonateSuccess(payload));

        const currentUserDetails = getUserDetailsFromImpersonateResponse(personData);
        dispatch(setLoggedUserDetailsSuccess(currentUserDetails));

        dispatch(
          setPreviousCasDetails({
            activeCasDetails: { ...activeCasDetails },
            institutionDetails: { ...institutionDetails },
            reportMenus: { ...reportMenus },
          }),
        );
        sendGADimensions(sessionUser.userPrincipalId);
      };

      awsSessData && personData
        ? awsSessData.currentAuthUser.refreshSession(awsSessData.currentSession.refreshToken, callback)
        : void 0;
    } catch (err) {
      console.error(err);
      dispatch(setUserImpersonateRequestComplete());
    }
  };
};

export const checkImpersonationRole = (reportURL, userRole) => {
  if (reportURL.includes('casid')) {
    const rolesCanImpersonate = ['ADMINISTRATOR_USER', 'REPORT_USER', 'INSTITUTION_USER'];
    if (rolesCanImpersonate.includes(userRole)) {
      return true;
    }
  } else if (reportURL.includes('casuniqueid')) {
    const rolesCanImpersonate = ['ASSOCIATION_USER'];
    if (rolesCanImpersonate.includes(userRole)) {
      return true;
    }
  }
  return false;
};

async function fetchCurrentAWSSessionData() {
  const currentAuthUser = await Auth.currentAuthenticatedUser();
  const currentSession = await Auth.currentSession();
  const response = {
    currentAuthUser,
    currentSession,
  };
  return response;
}

const getUserDetailsFromImpersonateResponse = (payload) => {
  return {
    given_name: payload.given_name,
    family_name: payload.family_name,
    userRole: payload['custom:userRole'],
    userRoleConstant: payload['custom:userRole'],
    email: payload.email,
    phone_number: payload.phone_number,
    userPrincipalId: payload['custom:userPrincipalId'],
  };
};
